import React, { ComponentProps } from 'react';
import IForm from '../../../types/IForm';
import { IFileItem } from '../../../types/api/FileItem';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { AttachedFilesUploadCreateForm } from '../forms/AttachedFilesUploadCreateForm';
import { asFetchableView } from '../../../_lib/ViewFetcher';
import { AttachedFilesBaseSortableList } from '../../../_lib/components/AttachedFilesBase';
import { AttachedFilesBaseSortableListModifier } from '../../../_lib/components/AttachedFilesBase/AttachedFilesBaseSortableList';
import { ComboBoxParam, SonForm } from '../../../_lib/Form2';
import { AnyParameter } from '../../../_lib/Form2/types/SonForm';

export type AttachedFilesEditViewProps = {
  fileLink: SonForm<ComboBoxParam<'fileResourceReference'>>;
  fileUpload: IForm;
  attachedFileUpdateOrder: SonForm<AnyParameter>;
  attachments: IFileItem[];
};

function AttachedFiles({ fileLink, fileUpload, attachedFileUpdateOrder, attachments }: AttachedFilesEditViewProps) {
  const { t } = useSonTranslation('AttachedFiles');

  return (
    <>
      <AttachedFilesUploadCreateForm fileLink={fileLink} fileUpload={fileUpload} />
      <AttachedFilesBaseSortableList
        headline={t('headlineList')}
        attachedFileUpdateOrder={attachedFileUpdateOrder}
        attachments={attachments}
        headlineModifier={AttachedFilesBaseSortableListModifier.PADDING}
      />
    </>
  );
}
export const AttachedFilesEditView = asFetchableView(AttachedFiles);
export type AttachedFilesEditView = ComponentProps<typeof AttachedFilesEditView>;
